<template>
	<div class="baseadddpercent">
		<el-row>
		<el-col :span="7"><span style="color:#ffffff">占</span></el-col>
		<el-col :span="10">
			<div style="font-size:20px;padding-top:10px;">
				<span>{{ p_name }}</span>
			</div>
		</el-col>
		<el-col :span="7"><span style="color:#ffffff">占</span></el-col>
	</el-row>
	<div style="height:10px;"></div>
	<el-row>
		<el-col :span="7"><span style="color:#ffffff">占</span></el-col>
		<el-col :span="10">
			<el-form label-width="90px" size="mini">
				<el-form-item label="方案名称">
					<el-input v-model="percwinfo.c_name" @input="changeinput" type="text"></el-input>
				</el-form-item>
				<el-form-item label="备  注"><el-input v-model="percwinfo.remark" @input="changeinput" type="text" row="5"></el-input></el-form-item>
				<el-form-item label="是否返利">
					<el-switch
					  v-model="percwinfo.p_isvip"
					  :active-value="true"
					  :inactive-value="false"
					  active-color="#13ce66"
					  inactive-color="#cfccc6">
					</el-switch>
				</el-form-item>
			</el-form>
		</el-col>
		<el-col :span="7"><span style="color:transparent">占</span></el-col>
	</el-row>
	<div style="height:10px;">
		<div style="border-top:2px solid #d6d8d8;"></div>
	</div>
	<div ref="cwlist" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto','background-color':'#ffffff' }">
		<el-row>
			<el-col :span="7"><span style="color:#ffffff">占</span></el-col>
			<el-col :span="10">
				<el-card class="box-card">
					<div v-for="(item,index) in percwinfo.list" :key="index">
						<el-form label-width="90px" size="mini" style="background-color:#ffffff;margin-top:16px;">
							<el-form-item label="渠   道" style="background-color:#ffffff;">
								<el-select style="width:100%" v-model="item.p_mode">
									<el-option v-for="(opt, opti) in pmodelist" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="接口报价 + " style="background-color:#ffffff;">
								<el-input placeholder="请输入比例" v-model="item.bl" @input="changeinput" style="width:47%" type="number">
									<template slot="append">
										%
									</template>
								</el-input>
								<span> + </span>
								<el-input placeholder="请输入金额" v-model="item.price" @input="changeinput" style="width:48%" type="number">
								</el-input>
							</el-form-item>
							<el-form-item style="background-color:#ffffff;" label="签收费"><el-input v-model="item.sign" @input="changeinput" type="number" placeholder="请输入金额"></el-input></el-form-item>
							<el-form-item label="保价费" style="background-color:#ffffff;">
								<el-select 
								@change="val => changeinsured(val, index)"
								v-model="item.insuredtype" style="width:100%" placeholder="请选择计算方式">
									<el-option v-for="(opt, opti) in insuredtype" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
								</el-select>
								<span style="background-color:#ffffff;color:#b6b6b6;font-size:9pt;line-height:5px;">{{item.insuredremark}}</span>
							</el-form-item>
						</el-form>
						<div style="text-align:right;border-bottom: 1px solid #cecece;">
							<i class="el-icon-delete" size="25" style="color:#ffa940;cursor: pointer;"  @click="removeset(index)"></i></div>
					</div>
					<el-row>
						<el-col :span="7"><span style="color:#ffffff">占</span></el-col>
						<el-col :span="10">
							<div style="text-align:center;padding-top:5px">
								<el-button type="primary" size="small" icon="el-icon-circle-plus-outline" @click="addset">添加渠道设置</el-button>
							</div>
						</el-col>
						<el-col :span="7"><span style="color:#ffffff">占</span></el-col>
					</el-row>
				</el-card>
			</el-col>
			<el-col :span="7"><span style="color:#ffffff">占</span></el-col>
		</el-row>
	</div>
	<el-row>
		<el-col :span="7"><span style="color:#ffffff">占</span></el-col>
		<el-col :span="10"><br/>
			<div style="height:20px;padding-top:5px;"></div>
		</el-col>
	</el-row>
	<el-row class="footerhandler">
		<el-col :span="4" class="submitBtn_switch" style="color:transparent;">1</el-col>
		<el-col :span="5" class="submitBtn"><div @click="savepayrule">保存</div></el-col>
		<el-col :span="1" style="color:transparent">1</el-col>
		<el-col :span="6" class="cancelBtn" ><div @click="rebacksetscheme">返回</div></el-col>
		<el-col :span="7" class="submitBtn_switch"></el-col>
	</el-row>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	components: {},
	props: {},
	data() {
		return {
			percwinfo: {
				c_id: '',
				c_name: '',
				remark: '',
				p_type: '',
				p_isvip:false,
				list:[]
			},
			percw:{
				bl: '',
				price:'',
				p_mode:'',
				sign:'',
				insuredtype:'',
				insuredremark:''
			},
			p_name:'',
			ischange: false,
			pmodelist:[],
			insuredtype:[{title:'',remark:'不计算'},{title:'区间取整计算',remark:'例如：购买保险金额是1-100，保价费收1；购买保险金额是100-200，保价费收2，以此类推...'}],
			divclass:'baseadddpercent',
			windowHeight: window.innerHeight -350
		};
	},
	mounted() {},
	methods: {
		init(param) {
			debugger
			if (param != '' && param != undefined) {
				this.percwinfo={
					c_id: '',
					c_name: '',
					remark: '',
					p_type: '',
					p_isvip:false,
					list:[{
						bl: '',
						price:'',
						p_mode:'',
						sign:'',
						insuredtype:'',
						insuredremark:''
					}]
				},
				this.percwinfo.list.push(JSON.parse(JSON.stringify(this.percw)));
				this.p_name = param.p_name;
				if (param.percwinfo != undefined) {
					if (param.percwinfo.c_id != undefined) this.percwinfo.c_id = param.percwinfo.c_id;
				} else {
					this.ischange = false;
				}
				this.isedit = param.isedit;
				this.GetCurrentscheme();
				this.GetClearance();
			}
		},
		addset(){
			this.percwinfo.list.push(JSON.parse(JSON.stringify(this.percw)));
			this.$nextTick(() => {
				this.$refs.cwlist.scrollTop = this.$refs.cwlist.scrollHeight;
			});
		},
		removeset(index){
			if(this.percwinfo.list.length>1)
				this.percwinfo.list.splice(index,1);
		},
		GetCurrentscheme() {
			var that = this;
			if (this.percwinfo.c_id != '' && this.percwinfo.c_id != undefined) {
				var paraminfo = {
					c_id: this.percwinfo.c_id,
					ismain: 0
				};
				this.$apipost.get.Getscheme({ paraminfo: paraminfo }).then(res => {
					debugger
					this.$tool.loadingclose();
					if (res != '') {
						if (res.cwinfo != undefined) {
							res.cwinfo.list=[that.percw];
							that.percwinfo=res.cwinfo;
							if(res.paylist!=undefined){
								res.paylist.forEach(e=>{
									if(e.insuredtype!=''){
										that.insuredtype.forEach(b=>{
											if(b.title==e.insuredtype){
												e.insuredremark=b.remark;
												return false;
											}
										});
									}
								});
								//that.percwinfo=res.cwinfo;
								that.percwinfo.list=res.paylist;
								that.GetClearance();
							}
						} else {
							this.$tool.message('读取方案失败，请重新打开', 0);
						}
					}
				});
			}
		},
		//获取渠道
		GetClearance(){
			var that=this;
			this.$apipost.get.GetClarance().then(res => {
				that.pmodelist = res.list;
				if(that.isedit=='0'||res.list.length==1){
					that.percwinfo.list[0].p_mode=that.pmodelist[0].d_value;
				}
			});
		},
		//保存财务方案
		savepayrule() {
			var that=this,isgo=true,iszero=false;
			if (this.percwinfo.c_name == '') {
				this.$tool.message('请输入方案名称', 0);
				return false;
			}
			if(this.percwinfo.list.length>0){
				var list=[];
				this.percwinfo.list.forEach(e=>{
					var isexists=false;
					list.forEach(b=>{
						if(e.p_mode==b.p_mode)
						{
							isexists=true;
							return false;
						}
					});
					if(isexists){
						this.$tool.message('渠道'+e.p_mode+'设置了重复的方案', 0);
						isgo=false;
						return false;
					}
				});
				if(isgo){
					for(var i=0;i<this.percwinfo.list.length;i++){
						if(this.percwinfo.list[i].p_mode==''){
							this.$tool.message('第'+(parseInt(i)+1)+'个模块请选择渠道', 0);
							isgo=false;
							break;
						}
						if(isNaN(parseFloat(this.percwinfo.list[i].bl))&&isNaN(parseFloat(this.percwinfo.list[i].price))){
							this.$tool.message('第'+(parseInt(i)+1)+'个模块请输入比例或者金额', 0);
							isgo=false;
							break;
						}
						if(parseFloat(this.percwinfo.list[i].bl)<0){
							this.$tool.message('第'+(parseInt(i)+1)+'个模块比例必须大于0', 0);
							isgo=false;
							break;
						}
						if(parseFloat(this.percwinfo.list[i].price)<0){
							this.$tool.message('第'+(parseInt(i)+1)+'个模块金额必须大于0', 0);
							isgo=false;
							break;
						}
						if(parseFloat(this.percwinfo.list[i].sign)<0)
						{
							this.$tool.message('第'+(parseInt(i)+1)+'个模块签收费必须大于0', 0);
							isgo=false;
						}
					}
				}
			}else{
				this.$tool.message('请添加渠道设置', 0);
				isgo=false;
			}
			if(isgo){
				var list=this.percwinfo.list.filter(function(e){
					return parseFloat(e.bl) == 0&&parseFloat(e.price) == 0;
				});
				if(list.length>0){
					this.$confirm('您设置的接口报价附加比例和金额均为0，确认要保存吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
						closeOnClickModal: false
					})
						.then(() => {
							that.savepayrule2();
						});
				}else{
					that.savepayrule2();
				}
			}
			else{
				return false;
			}
		},
		savepayrule2(){
			var that = this;
			var paylist=[];
			var paraminfo=[],percwinfo=JSON.parse(JSON.stringify(this.percwinfo));
			percwinfo.list.forEach(e=>{
				paylist.push({p_mode:e.p_mode,paytype:'',unit:'百分比',price:e.bl});
				paylist.push({p_mode:e.p_mode,paytype:'',unit:'金额',price:e.price});
				paylist.push({p_mode:e.p_mode,paytype:'签收费',unit:'金额',price:e.sign});
				paylist.push({p_mode:e.p_mode,paytype:'保价费',unit:e.insuredtype,price:0});
			});
			percwinfo.list=paylist;
			percwinfo.u_userid=localStorage.getItem('userid');
			percwinfo.p_type="取接口报价加签收费保价费附加费";
			paraminfo.push(percwinfo);
			
			this.$tool.loading('正在保存', this.divclass);
			this.$apipost.post.Savescheme({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message('保存成功', 1);
					that.ischange = false;
					that.rebacksetscheme();
				} else {
					this.$tool.message(res.message, 0);
				}
			});	
		},
		rebacksetscheme() {
			if (this.ischange) {
				this.$confirm('您的信息有更改，确定放弃保存吗?', '提示', {
					confirmButtonText: '放弃',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.$emit('reback', {});
				});
			} else {
				this.$emit('reback', {});
			}
		},
		changeinput() {
			this.ischange = true;
		},
		changeinsured(val,index){
			var that=this;
			var list=this.insuredtype.filter(function(e){
				return e.title==val;
			});
			if(list.length>0){
				this.percwinfo.list[index].insuredremark=list[0].remark;
			}
		}
	}
};
</script>
